import Pagination from '@mui/material/Pagination';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';
import { INDIGO_PRIMARY, INDIGO_900, SLATE_200, WHITE } from '../colors';

interface Props {
  /*
   * data passed to next/Router
   * */
  routingData?: {
    /*
     * root pathname
     * */
    pathname: string;
    /*
     * query param
     * */
    queryParamName: string;
    /*
     * value of query param
     * */
    queryParamValue: string;
  };
  /*
   * total pages count
   * */
  count: number;
  pageChanged?: (page: number) => void;
  /*
   * key properties of current router
   * */
  keepRouterContext?: boolean;
}

export default function RoutingPaginationButtons(props: Props) {
  const { routingData, count } = props;
  const router = useRouter();

  const onPageChange = (event, page: number) => {
    event.preventDefault();
    event.stopPropagation();

    if (props.pageChanged) {
      props.pageChanged(page);
    }

    if (props.keepRouterContext) {
      router.query.p = `${page}`;
      router.push(router);
    } else if (!props.routingData) {
      throw new Error(
        'when props.keepRouterContext is false then you have to provide a routingData prop.',
      );
    } else {
      router.push(
        `${routingData.pathname}?${routingData.queryParamName}=${routingData.queryParamValue}&p=${page}`,
      );
    }
  };

  const getPage = (): number => {
    const { p } = router.query;

    return Number(p) || 1;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        '& > *': {
          my: 2,
        },
        '& .MuiPaginationItem-root': {
          color: SLATE_200,
        },
        '& .MuiPaginationItem-root.Mui-selected': {
          backgroundColor: INDIGO_PRIMARY,
          color: WHITE,
          '&:hover': {
            backgroundColor: INDIGO_900,
          },
        },
      }}
    >
      <Pagination
        page={getPage()}
        translate={'no'}
        count={count}
        showFirstButton
        showLastButton
        onChange={onPageChange}
      />
    </Box>
  );
}
